import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentManagementComponent } from './environment-management/environment-management.component';
import { CustomerUserManagementComponent } from './customer-user-management/customer-user-management.component';
import { ModuleManagementComponent } from './module-management/module-management.component';

@Component({
  selector: 'app-customer-data-management',
  standalone: true,
  imports: [
    CommonModule,
    EnvironmentManagementComponent,
    CustomerUserManagementComponent,
    ModuleManagementComponent
  ],
  templateUrl: './customer-data-management.component.html',
  styleUrl: './customer-data-management.component.scss'
})
export class CustomerDataManagementComponent implements OnInit {

  // 分頁管理
  activeTab: 'environment' | 'users' | 'modules' = 'environment';

  // 子元件參考
  @ViewChild('environmentComponent') environmentComponent?: EnvironmentManagementComponent;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * 切換分頁
   */
  switchTab(tab: 'environment' | 'users' | 'modules'): void {
    this.activeTab = tab;
  }

  /**
   * 處理模組更新事件，刷新環境管理的資料
   */
  onModuleUpdated(): void {
    if (this.environmentComponent) {
      this.environmentComponent.refreshEnvironments();
    }
  }
}